module.exports = __webpack_public_path__ + "img/14_hereon.73656cd6.jpg";